<template>
  <div class="wrapper">
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import Qs from 'qs'
  import Url from '@/views/newmis36/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  let type = {1:"短信发送",2:"邮件发送"};
  let device = {"PC":"PC","M":"M"};
  export default {
    name: 'list',
    components: {
      tablePage,
    },
    mounted(){
        this.$refs.childTable.defaultQueryData();
    },
    methods: {
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "modify") {
           this.dataChanage(Url.smsType.edit,row,(res)=>{
               this.$refs.childTable.defaultQueryData();
               if (res.code == 0){
                   this.$message.success("suc");
               }else{
                   this.$message.error(res.message);
               }
           })
        }
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
            if(suc && (typeof suc == 'function')) suc(res);
        }).catch(res => {
            if(fail && (typeof fail == 'function')) fail(res);
        })
      }
    },
    data () {
      return {
        queryData:{},
        /*table生成*/
        pageData: {
          queryUrl: Url.smsType.list, //请求路径和参数
          sequence: true,
          isPage:false,
          cols: [
              { title:window.$t('txmis.smsType.device'), field: 'device'},
              { title:window.$t('txmis.smsType.type'), field: 'type', render: (data, full) => {
                      return type[data];
                  }},
              { title:window.$t('txmis.smsType.updateTime'), field: 'updateTime',render: (data, full) => {
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              {field:window.$t('txmis.smsType.modify'),title:window.$t('txmis.bt.operation'),size:"mini",click:"modify",type:"primary",icon:"el-icon-edit"},
          ]
        }
      }
    }
  }
</script>
